import SetpAlertRulesAgenda from '../../components/alert-rules-agenda'

export default {
  SetpAlertRulesAgenda
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/index/resources/components.js